/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.10.1
 * @since 1.0.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../theme';
import { IAttrStyled } from '../../../types/globalTypes';

const FormContainerStyled = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 40px 56px;
    border: 1px solid ${colors.pageAuthBorderColor};
    position: relative;

    & .block-with-icon {
        width: auto;
        position: absolute;
        top: 30px;
        right: 30px;
    }
`;
const FormWrapperStyled = styled.form.attrs(({ className }: IAttrStyled) => ({
    className: `form ${className || ''}`,
}))<IAttrStyled>`
    max-width: 320px;
    box-sizing: border-box;

    & button {
        width: 100%;
    }

    & p {
        margin: 0;
    }

    & a {
        ${fonts.textLink};
        text-decoration: none;
    }
`;
const FormTitleStyled = styled.div.attrs(({ className }: { className: string }) => ({
    className: `form__title ${className || ''}`,
}))`
    ${fonts.textHeader3};
    font-size: 26px;
`;
const FormSubtitleStyled = styled.p.attrs(({ className }: { className: string }) => ({
    className: `form__subtitle ${className || ''}`,
}))`
    ${FormWrapperStyled} & {
        margin-bottom: 2.6rem;
    }

    font-size: 13px;
`;

const FormHelpStyled = styled.span.attrs({
    className: 'form__help',
})`
    ${fonts.textSmall};
    color: ${colors.pageAuthTextColorSecondary};
`;

const FormGroupStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `form__group ${className || ''}`,
}))<IAttrStyled>`
    margin-bottom: 1em;

    &.form-group__password-input .input__container img {
        width: 20px;
    }
`;

const PageAuthStyled = styled.div`
    margin: 80px auto;
    width: 100%;
    max-width: 828px;
`;

export {
    FormContainerStyled,
    FormGroupStyled,
    FormHelpStyled,
    FormSubtitleStyled,
    FormTitleStyled,
    FormWrapperStyled,
    PageAuthStyled,
};
